(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpDaterangepicker', cpDaterangepicker);

    cpDaterangepicker.$inject = ['momentSrvc', '$timeout'];

    function cpDaterangepicker(momentSrvc, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/daterangepicker/daterangepicker.html',
            scope: {
                title: '@',
                inputclass: '@',
                object: '=',
                format: '=',
                prop: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?',
            },
            link: function(scope, element, attrs, controller) {
                if (!scope.format) {
                    scope.format = 'YYYY.MM.DD'
                }
                scope.options = {
                    pickerClasses: 'custom-display',
                    buttonClasses: 'btn',
                    applyButtonClasses: 'btn-primary',
                    cancelButtonClasses: 'btn-danger',
                    format: scope.format,
                    drops: 'down',

                    locale: {
                        applyLabel: 'Zastosuj',
                        cancelLabel: 'Anuluj',
                        separator: ' - ',
                        format: scope.format,
                        monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
                        daysOfWeek: ['Nd', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
                        firstDay: 1
                    },
                    eventHandlers: {
                        'apply.daterangepicker': function(event, picker) { scope.onChange(); }
                    },
                    maxDate: new Date()
                }
                scope.openPicker = function(elem) {
                    var elem = angular.element(angular.element(elem.currentTarget).parent().parent().children()[0]);
                    $timeout(function(){
                        elem.triggerHandler('click')
                    })
                }
            }
        };
    }
})();
